
/**
 * 메시지 상태 정보
 */
export type MessagingCreateChatRoom201LastMessageStatus = {
  isRead?: boolean;
};
